import React, { FC } from 'react'

import { css, cx } from '@linaria/core'
import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'

import { definitions } from 'api/generated/complaints'
import { VoidHandler } from 'common/types'
import { MenuIcon } from 'components/designSystem/MenuIcon/MenuIcon'
import { Slot } from 'components/designSystem/Slot/Slot'

export const ComplaintListNextView: FC<{
  showRealComplaints: boolean
  complaintListNotReal: definitions['ComplaintCause'][]
  complaintListReal: definitions['ComplaintCause'][]
  onShowRealComplaintsToggle: VoidHandler
  onClickSendComplaint: (causeId: number) => void
}> = ({
  complaintListNotReal,
  complaintListReal,
  showRealComplaints,
  onShowRealComplaintsToggle,
  onClickSendComplaint,
}) => {
  return (
    <Slot type="vertical">
      <Child
        className={cx(!showRealComplaints ? fadeInCss : fadeOutCss)}
        data-name="complaints-tooltip-list-not-real"
      >
        <MenuIcon
          tag="div"
          text={
            <FormattedMessage
              id="complaint.blocked"
              defaultMessage="Пожаловаться и заблокировать"
            />
          }
          fontSize={16}
          fontWeight={500}
          onClick={onShowRealComplaintsToggle}
          className={menuCss}
          data-name="go-to-real-complaints-action"
        />
        {complaintListNotReal.map(({ id, message }) => (
          <MenuIcon
            key={id}
            tag="div"
            text={message}
            fontSize={16}
            fontWeight={500}
            onClick={() => onClickSendComplaint(id)}
            className={menuCss}
            data-name={`complain-${id}-message`}
          />
        ))}
      </Child>
      <Child
        className={cx(showRealComplaints ? fadeInCss : fadeOutCss)}
        data-name="complaints-tooltip-list-real"
      >
        {complaintListReal.map(({ id, message }) => (
          <MenuIcon
            key={id}
            tag="div"
            text={message}
            fontSize={16}
            fontWeight={500}
            onClick={() => onClickSendComplaint(id)}
            className={menuCss}
            data-name={`complain-${id}-message`}
          />
        ))}
        <MenuIcon
          tag="div"
          text={<FormattedMessage id="back" defaultMessage="Назад" />}
          fontSize={16}
          fontWeight={500}
          onClick={onShowRealComplaintsToggle}
          className={menuCss}
        />
      </Child>
    </Slot>
  )
}

const Child = styled.div`
  transition: opacity 0.5s ease, height 0.5s ease;
  overflow: hidden;
`

const fadeInCss = css`
  opacity: 1;
  height: auto;
  width: auto;
`

const fadeOutCss = css`
  opacity: 0;
  height: 0;
  width: 0;
`

const menuCss = css`
  padding: var(--spacing-16px) 0;
  cursor: pointer;
`
